import {defineSlotRecipe} from '@chakra-ui/react3'

export const newsletterSlotRecipe = defineSlotRecipe({
    className: 'newsletter',
    slots: ['layout', 'card', 'textGroup', 'confirmation', 'media'],

    base: {
        layout: {
            display: 'flex',
            flexDirection: {base: 'column-reverse', s: 'row'},
            gap: 'spacing-16'
        },
        card: {
            flex: {s: '1 1 50%'},
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: 'spacing-24',
            width: '100%',
            borderRadius: 's',
            paddingY: {base: 'spacing-40', s: 'spacing-90'},
            paddingX: {base: 'spacing-24', s: 'spacing-90'}
        },
        textGroup: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-16'
        },
        confirmation: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-16',
            _focus: {
                outline: 'none'
            }
        },
        media: {
            flex: {s: '1 1 50%'},
            // keeps the square asset's own height when the card grows taller, so the
            // rounded corners stay on the asset
            alignSelf: 'flex-start',
            width: '100%',
            borderRadius: 's',
            overflow: 'hidden'
        }
    },

    variants: {
        view: {
            signUp: {
                card: {
                    backgroundColor: 'var(--module-surface-bg-color)'
                }
            },
            confirmation: {
                card: {
                    backgroundColor: 'background.actions.primary'
                }
            }
        }
    },

    defaultVariants: {
        view: 'signUp'
    }
})
